export function isValidCompanyUid(value: string) {
    return /^CHE-(\d{3}\.){2}\d{3}$/.test(value);
}
